module.exports = __webpack_public_path__ + "static/media/two.e91e7d82.svg";